import { useEffect } from "react";

const SHORTCUTS = [
  { keys: ["⌘", "K"], label: "Search / Command Palette" },
  { keys: ["N"], label: "New Brief" },
  { keys: ["?"], label: "Toggle this panel" },
  { keys: ["Esc"], label: "Close dialogs" },
  { keys: ["↑", "↓"], label: "Navigate search results" },
  { keys: ["↵"], label: "Select search result" },
];

const NAV_SHORTCUTS = [
  { keys: ["G", "then", "D"], label: "Go to Dashboard (My Day)" },
  { keys: ["G", "then", "B"], label: "Go to Briefs Board" },
  { keys: ["G", "then", "L"], label: "Go to Leads" },
  { keys: ["G", "then", "T"], label: "Go to Tasks" },
  { keys: ["G", "then", "A"], label: "Go to Accounts" },
];

export default function KeyboardShortcuts({ onClose }) {
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, zIndex: 9998,
      display: "flex", alignItems: "center", justifyContent: "center",
      background: "rgba(0,0,0,.6)", backdropFilter: "blur(6px)",
      animation: "dmFadeUp .2s ease-out",
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: "var(--s1)", border: "1px solid var(--bdr)",
        borderRadius: "var(--radius)", width: "100%", maxWidth: 420,
        margin: "0 16px", boxShadow: "0 20px 60px rgba(0,0,0,.5)",
      }}>
        {/* Header */}
        <div style={{
          padding: "14px 20px", borderBottom: "1px solid var(--bdr)",
          display: "flex", justifyContent: "space-between", alignItems: "center",
        }}>
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--t2)", letterSpacing: ".12em" }}>KEYBOARD SHORTCUTS</span>
          <button onClick={onClose} style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--t3)", background: "var(--s3)", border: "1px solid var(--bdr)", borderRadius: 4, padding: "2px 8px", cursor: "pointer" }}>ESC</button>
        </div>

        {/* General */}
        <div style={{ padding: "12px 20px" }}>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 9, color: "var(--t3)", letterSpacing: ".15em", marginBottom: 8 }}>GENERAL</div>
          {SHORTCUTS.map((s, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0" }}>
              <span style={{ fontFamily: "var(--font-sans)", fontSize: 13, color: "var(--t2)" }}>{s.label}</span>
              <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                {s.keys.map((k, j) => (
                  k === "then" ? <span key={j} style={{ fontFamily: "var(--font-mono)", fontSize: 9, color: "var(--t3)" }}>then</span> :
                  <kbd key={j} style={{
                    fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--t1)",
                    background: "var(--s3)", border: "1px solid var(--bdr)",
                    borderRadius: 4, padding: "2px 7px", minWidth: 22, textAlign: "center",
                  }}>{k}</kbd>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Navigation */}
        <div style={{ padding: "4px 20px 16px" }}>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 9, color: "var(--t3)", letterSpacing: ".15em", marginBottom: 8, paddingTop: 8, borderTop: "1px solid var(--bdr)" }}>NAVIGATION</div>
          {NAV_SHORTCUTS.map((s, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0" }}>
              <span style={{ fontFamily: "var(--font-sans)", fontSize: 13, color: "var(--t2)" }}>{s.label}</span>
              <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                {s.keys.map((k, j) => (
                  k === "then" ? <span key={j} style={{ fontFamily: "var(--font-mono)", fontSize: 9, color: "var(--t3)" }}>then</span> :
                  <kbd key={j} style={{
                    fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--t1)",
                    background: "var(--s3)", border: "1px solid var(--bdr)",
                    borderRadius: 4, padding: "2px 7px", minWidth: 22, textAlign: "center",
                  }}>{k}</kbd>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{ padding: "10px 20px", borderTop: "1px solid var(--bdr)", textAlign: "center" }}>
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--t3)" }}>Press <kbd style={{ fontFamily: "var(--font-mono)", fontSize: 10, background: "var(--s3)", border: "1px solid var(--bdr)", borderRadius: 3, padding: "1px 5px" }}>?</kbd> anywhere to toggle</span>
        </div>
      </div>
    </div>
  );
}
